// İşçi sessiyasının etibarlılığı — POS rejimində İKİ token var.
//
// ═══ NİYƏ AYRICA MODUL ═══
//
// POS-da iki müstəqil token işləyir:
//
//   `token`      — bulud Sanctum token-i (cloud API üçün)
//   `pos_token`  — pos_local sessiyası (masa, sifariş, printer — bütün POS işi)
//
// Onların ÖMÜRLƏRİ FƏRQLİDİR. pos_local yenidən başlayanda (cihaz yenidən
// qeydiyyatdan keçəndə, backend çökəndə, sessiya vaxtı bitəndə) bütün POS
// sessiyaları silinir — bulud token-i isə localStorage-də qalır.
//
// ═══ BUNUN YARATDIĞI NASAZLIQ ═══
//
// Front "giriş edilib"i yalnız `token`-ə görə müəyyən edirdi. Nəticədə:
//
//   1. işçi POS səhifəsinə keçir → pos_local 401 verir
//   2. handler onu `/`-a (giriş ekranına) yönləndirir
//   3. Login `token`-i görüb DƏRHAL geri `/masalar`-a atır
//   4. yenidən 401 → dövrə
//
// İşçi heç vaxt PIN ekranını görmürdü, amma POS əməliyyatları da işləmirdi —
// "avtomatik giriş olur, printerə keçəndə xəta verir" şikayətinin səbəbi.
//
// Ona görə POS rejimində sessiya HƏR İKİ token varsa etibarlıdır.

import { POS_ENABLED } from './config';
import { getPosToken } from './posClient';

/**
 * İşçi işləməyə hazırdırmı.
 *
 * Brauzerdə (POS rejimi sönülü) yalnız bulud token-i əsasdır — orada
 * pos_local ümumiyyətlə yoxdur.
 */
export function hasWorkingSession(): boolean {
  if (typeof localStorage === 'undefined') return false;
  if (!localStorage.getItem('token')) return false;
  if (POS_ENABLED && !getPosToken()) return false;
  return true;
}

/**
 * İşçi sessiyasını təmizlə (PIN ilə yenidən giriş üçün).
 *
 * Cihaz kimliyinə (`device_token`, `staff_list`) TOXUNULMUR — onlar cihaza
 * aiddir, işçiyə yox. Əks halda hər PIN vaxtı bitəndə terminal yenidən
 * quraşdırma tələb edərdi.
 */
export function clearStaffSession(): void {
  for (const key of ['token', 'role', 'staff_role', 'staff_permissions']) {
    localStorage.removeItem(key);
  }
}

// ───────────────────────────────────────────────────────────────────────────
// İCAZƏLƏRİN İŞÇİ ÜZRƏ KEŞİ
//
// `staff_permissions` TƏK açardır — hazırkı sessiyaya aiddir. Oflayn girişdə
// bulud cavabı olmur, yəni icazə siyahısı boş gəlir, və kod onu "əvvəlki
// dəyəri əzmə" məntiqi ilə OLDUĞU KİMİ saxlayırdı.
//
// Nəticə: menecer terminaldan çıxır, sonra ofisant oflayn daxil olur —
// və menecerin icazələri ilə işləyir. Səlahiyyət artımı, tamamilə səssiz.
//
// Ona görə icazələr işçi id-si ilə açarlanır: oflayn giriş HƏMİN işçinin
// son məlum siyahısını bərpa edir, başqasınınkını yox. Tanınmayan işçi üçün
// boş siyahı qaytarılır — sonra rol adına görə minimal fallback işləyir.
// ───────────────────────────────────────────────────────────────────────────

const PERMISSION_CACHE_KEY = 'staff_permissions_by_id';

type PermissionCache = Record<string, string[]>;

function readCache(): PermissionCache {
  try {
    const raw = localStorage.getItem(PERMISSION_CACHE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

/** Onlayn girişdən sonra bu işçinin effektiv icazələrini yadda saxla. */
export function rememberStaffPermissions(staffId: string | number, permissions: string[]): void {
  const id = String(staffId ?? '').trim();
  if (!id || !Array.isArray(permissions)) return;
  try {
    const cache = readCache();
    cache[id] = permissions;
    localStorage.setItem(PERMISSION_CACHE_KEY, JSON.stringify(cache));
  } catch {
    /* kvota / private mode — keş məcburi deyil */
  }
}

/** Oflayn giriş: bu işçinin son məlum icazələri (yoxdursa boş siyahı). */
export function recallStaffPermissions(staffId: string | number): string[] {
  const id = String(staffId ?? '').trim();
  if (!id) return [];
  const value = readCache()[id];
  return Array.isArray(value) ? value : [];
}
